import React from 'react';
import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';
import { FormattedMessage } from 'react-intl';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';

export const OrderDate = {
  getName: () => <FormattedMessage defaultMessage='Order Date' description='customersOrdersGrid.columns.orderDate' id='IomT4l' />,
  id: 'orderDate',

  render: (data) => {
    const { orderNumberCount, orderDateTime } = data;
    if (orderNumberCount > 1) {
      return <Multiple />;
    }

    if (!orderDateTime) {
      return null;
    }
    return <UserDateTimezoneFormat dateTime={orderDateTime} />;
  },
};
